import * as THREE from 'three';
import AssetRepository from './engine-lite/assetRepository.js';
import { EngineUtils } from './engineUtils.js';
import { MobileControls } from './mobileControls.js';
import { TextureOptimizer } from './textureOptimizer.js';
import { GameLogic } from './logic.js';
import { GameLogic2Scene3 } from './logic2Scene3.js';

let gameLogic = null;
let gameLogic2 = null;



import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';


let camera, scene, renderer, labelRenderer, composer, mouseBox, monitor, orbitControls, folderLabel;
let mouseX = 0, mouseY = 0, isAtDesk = false;
const initialRotation = new THREE.Euler();

// Глобальное состояние игры
window.gameState = { 
    camera: null, 
    scene: null, 
    persons: [], 
    video: null, 
    texture: null, 
    raycaster: null,
    monitorMaterial: null,
    startBtn: null
};

export async function initMainSecondScene() {
    const container = document.getElementById('container');
    const labelContainer = document.getElementById('labels-container') || document.body;
    
    
    // 1. Базовая сцена и камера
    scene = EngineUtils.createScene(0xffffff);
    camera = EngineUtils.createCamera(60, 0.1, 20, 5);
    renderer = EngineUtils.createRenderer(container);
    camera.position.set(.8, 1.2, .8);

    // 2. CSS2D рендерер для плавающих надписей
    labelRenderer = new CSS2DRenderer();
    labelRenderer.setSize(window.innerWidth, window.innerHeight);
    labelRenderer.domElement.style.position = 'absolute';
    labelRenderer.domElement.style.top = '0px';
    labelRenderer.domElement.style.pointerEvents = 'none';
    labelContainer.appendChild(labelRenderer.domElement);

    // 3. Свет и Пост-обработка
    EngineUtils.setupLighting(scene, ['p2', 'p3', 'p4']);
    composer = EngineUtils.createComposer(renderer, scene, camera);
    
    window.gameState.camera = camera; 
    window.gameState.scene = scene;

    // 4. Мобильное управление (OrbitControls)
    if (MobileControls.isTouchDevice()) {
        orbitControls = new OrbitControls(camera, renderer.domElement);
        orbitControls.target.set(0.79, 1.2, 0.8);
        orbitControls.enablePan = false;
        orbitControls.enableZoom = false;
        orbitControls.update();
    }

    // 5. Видео-текстуры для 2 мониторов (одновременно)
    const video = document.getElementById('video');
    const video2 = document.getElementById('video2');

    video.play().catch(() => console.warn("Автоплей видео #1 заблокирован"));
    video2.play().catch(() => console.warn("Автоплей видео #2 заблокирован"));

    const texture1 = new THREE.VideoTexture(video);
    texture1.flipY = false;
    texture1.colorSpace = THREE.SRGBColorSpace;

    const texture2 = new THREE.VideoTexture(video2);
    texture2.flipY = false;
    texture2.colorSpace = THREE.SRGBColorSpace;

    window.gameState.video1 = video;
    window.gameState.video2 = video2;
    window.gameState.texture1 = texture1;
    window.gameState.texture2 = texture2;


    // 6. Загрузка ассетов
    const assetRepo = new AssetRepository();
    await assetRepo.loadAssetsFromAssetListFile("/assets/prefabsList.json");
    const modelScene2 = await assetRepo.createFromAsset("sc3");

    // 6.1 Инициализация GameLogic под сценарий 2 (scene3)
    // Пока используем тот же dialogs.json, т.к. сцен.2 JSON может отсутствовать.
    // Когда появится отдельный dialogs_scenario2.json — сюда добавим dialogsUrl/scenarioId.
    // Инициализация общей GameLogic (нужна как медиаплеер для playVideo)
    const dialogsUrl = './assets/dialogs.json';
    gameLogic = new GameLogic();
    await gameLogic.init({ dialogsUrl, scenarioId: 2, monitorMaterials: window.gameState.monitorMaterials });

    // Специализированная линейная логика сценария 2
    gameLogic2 = new GameLogic2Scene3({
        videoElement: document.getElementById('video'),
        subtitleElement: document.getElementById('subtitle-container'),
        monitorMaterials: window.gameState.monitorMaterials,
        audioBaseUrl: './assets'
    });


    
    modelScene2.traverse((obj) => {
        if (obj.isMesh) {
            TextureOptimizer.optimizeMesh(obj); 
            obj.castShadow = obj.receiveShadow = true;
        }
    });
    scene.add(modelScene2);

    // 7. Поиск объектов в модели
    // mouseBox = modelScene2.getObjectByName("mouse");
    
    // if (mouseBox) {
    //     mouseBox.traverse(c => { if (c.isMesh) c.userData.interactive = true; });
    // }


    // 9. Настройка мониторов (2 экрана)
    const monitor1 = modelScene2.getObjectByName("monitor1");
    const monitor2 = modelScene2.getObjectByName("monitor2");

    const resolveMonitorMesh = (node) => {
        if (!node) return null;
        if (node.isMesh) return node;
        const found = node.getObjectByProperty('isMesh', true);
        return found && found.isMesh ? found : null;
    };

    const m1 = resolveMonitorMesh(monitor1);
    const m2 = resolveMonitorMesh(monitor2);

    const materials = [];

    if (m1) {
        m1.material = new THREE.MeshPhongMaterial({
            map: texture1,
            emissive: 0xffffff,
            emissiveMap: texture1,
            emissiveIntensity: 1,
            side: THREE.DoubleSide
        });
        materials[0] = m1.material;
    }

    if (m2) {
        m2.material = new THREE.MeshPhongMaterial({
            map: texture2,
            emissive: 0xffffff,
            emissiveMap: texture2,
            emissiveIntensity: 1,
            side: THREE.DoubleSide
        });
        materials[1] = m2.material;
    }


    // Поддержка для GameLogic: монитор(ы) может быть 1 или 2
    window.gameState.monitorMaterials = materials;
    if (materials[0]) window.gameState.monitorMaterial = materials[0];


    // 12. UI/логика: «начать расследование» (обычная кнопка на экране, не 3D)
    const startInvestigationBtn = document.getElementById('startInvestigationBtn');
    if (startInvestigationBtn) {
        startInvestigationBtn.style.display = 'block';
        if (!startInvestigationBtn.dataset.boundScene2) {
            startInvestigationBtn.dataset.boundScene2 = '1';
            startInvestigationBtn.addEventListener('click', () => {
                if (gameLogic2) gameLogic2.onStartInvestigation();
                // НЕ скрываем кнопку здесь.
                // GameLogic2Scene3 сам управляет состояниями текста/показа.
            });
        }
    }
     

    // 13. Raycast по сцене (только телефон IPhone)
    // Сценарий 2: перемещений нет — только повороты.
    const phoneNode = modelScene2.getObjectByName('IPhone');
    if (phoneNode) {
        phoneNode.userData.interactive = true;
        if (gameLogic2 && gameLogic2.setPhoneNode) {
            gameLogic2.setPhoneNode(phoneNode, labelRenderer);
        }
    }



    const raycaster = new THREE.Raycaster();
    window.gameState.raycaster = raycaster;

    renderer.domElement.addEventListener('click', (e) => {
        if (!phoneNode) return;
        raycaster.setFromCamera(EngineUtils.getMouseNDC(e, renderer.domElement), camera);
        const hits = raycaster.intersectObject(phoneNode, true);
        if (!hits.length) return;

        if (!gameLogic2) return;
        gameLogic2.onPhoneClick();
    });

    // 13. Движение камеры мышью (Desktop)
    if (!MobileControls.isTouchDevice()) {
        camera.lookAt(new THREE.Vector3(-1, 1.08, .78));
        camera.rotation.reorder('YXZ');
        initialRotation.copy(camera.rotation);
        
        document.addEventListener('mousemove', (e) => { 
            mouseX = (e.clientX / window.innerWidth) * 2 - 1; 
            mouseY = (e.clientY / window.innerHeight) * 2 - 1; 
        });
    }
    
    window.addEventListener('resize', () => {
        EngineUtils.handleResize(camera, renderer, composer);
        if (labelRenderer) labelRenderer.setSize(window.innerWidth, window.innerHeight);
    });

    // Loader.hide(); 
    renderer.setAnimationLoop(animate);
}

export function animate() {
    if (MobileControls.isTouchDevice()) {
        if (orbitControls && orbitControls.enabled) orbitControls.update();
    } else {
        // Легкое покачивание камеры (Desktop)
        const targetRotX = initialRotation.x + (-mouseY * 0.03);
        const targetRotY = initialRotation.y + (-mouseX * 0.05);
        camera.rotation.x += (targetRotX - camera.rotation.x) * 0.1;
        camera.rotation.y += (targetRotY - camera.rotation.y) * 0.1;
    }

    // Рендеринг 3D
    composer.render();
    
    // Рендеринг HTML-надписей
    if (labelRenderer) {
        labelRenderer.render(scene, camera);
    }
}